<template>
  <AppImg src="/images/vietnam-market.webp" :alt="tCountry('VNM')" class="shadow" />
</template>

<script setup lang="ts">
const { tCountry } = useLocalization();
</script>